(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["xain-product-assurance"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-xain-open-details]');
    if (!link) return;
    const details = document.getElementById(link.dataset.xainOpenDetails);
    if (details?.tagName === 'DETAILS') details.open = true;
  });
  } catch(e) { console.error(e); }
})();

})();
